const openGrindInfoButton = document.querySelectorAll('.js-open-grind-info');
const closeGrindInfoButton = document.querySelector('.js-close-grind-info');
const grindInfoPopup = document.getElementById('popupGrindInfo');
const grindInfoBackdrop = document.getElementById('grindInfoBackdrop');
const grindInfoSelectButtons = grindInfoPopup.querySelectorAll('.js-select-grind-info');

openGrindInfoButton.forEach(function (button) {
    button.addEventListener('click', function () {
        grindInfoPopup.classList.add('show');
        grindInfoBackdrop.classList.add('show');
    });
});

grindInfoSelectButtons.forEach(function (button) {
    button.addEventListener('click', function () {
        const selectedValue = button.dataset.value;
        const radio = document.querySelector(`input[type="radio"][name="Type of grind"][data-label="${selectedValue}"]`);
        if (radio) {
            const selectElement = document.querySelector('select-field');

            if (selectElement && typeof selectElement.closeDropdown === 'function') {
                radio.click();
                setTimeout(() => {
                    selectElement.closeDropdown();
                }, 100);
            }
        }

        setTimeout(() => {
            grindInfoPopup.classList.remove('show');
            grindInfoBackdrop.classList.remove('show');
        }, 300);

    });
});

closeGrindInfoButton.addEventListener('click', function () {
    grindInfoPopup.classList.remove('show');
    grindInfoBackdrop.classList.remove('show');
});

window.addEventListener('click', function (event) {
    if (event.target === grindInfoBackdrop) {
        grindInfoPopup.classList.remove('show');
        grindInfoBackdrop.classList.remove('show');
    }
});
